import { Component, OnInit, Input, ViewChild, SimpleChanges, OnChanges, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { FormTableListComponent } from '../form-table-list/form-table-list.component';
import { DhlFormControlSearch } from '../../models/dhl-form-control-search';
import { AppService } from 'src/app/app.service';
import { ModalService } from 'src/app/common/modal/modal.service';
import { CommonConfig } from 'src/app/common/configuration/common.config';
import { APP_Constants } from 'src/app/app.constant';
import { Modal } from 'src/app/common/modal/modal';
import { FormService } from '../../services/form.service';
import { first } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomSnackBarService } from 'src/app/common/snack-bar/snack-bar.service';
import { DhlFormControlEvent } from '../../models/dhl-form-control-event';
import { DhlFormControlEventData } from '../../models/dhl-form-control-event-data';


@Component({
    selector: 'app-form-search-box',
    templateUrl: './form-search-box.component.html',
    styleUrls: ['./form-search-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormSearchBoxComponent implements OnInit, AfterViewInit {

  @Input() configData: DhlFormControlSearch;
  @Input() frmGroup: UntypedFormGroup;

  @ViewChild(FormTableListComponent, { static: true }) public table: FormTableListComponent;

  createOrderAccess: boolean = false;
  searchOrderAccess: boolean = false;
  releaseOrderAccess: boolean = false;

  color: String = 'primary';
  mode: String = 'indeterminate';
  isLoading: boolean = false;
  pageLoadingMessage: string = '';
  durationInSeconds = 20;
  searchBoxVal="";
  bulkuserData;
  pageSize: Number = 50;
  pageNumber: Number = 1;
  normalView() {
    document.getElementById("overlay").style.display = "none";
  }

  tabelConfig;
  constructor(private _snackBar: CustomSnackBarService, private formService: FormService, private router: Router, private appService: AppService, public dialog: MatDialog, private modalService: ModalService) {
    this.tabelConfig = this.appService.getSearchResultMetaData();
  }


  ngAfterViewInit() {
    let searchBox = document.getElementById('searchBox');
    let filterForm = document.getElementById('filter-form');
    if (filterForm)
      filterForm.style.width = searchBox.offsetWidth + 'px';
  }

  ngOnDestroy(){
    sessionStorage.removeItem(this.tabelConfig.httpConfig.sourceNodeName) ;
  }
  ngOnInit() {
    console.log(this.configData);
    console.log(this.frmGroup);
    sessionStorage.removeItem(this.tabelConfig.httpConfig.sourceNodeName) ;

    this.pageLoadingMessage = CommonConfig.PAGE_LOADING;

    let menuPages = JSON.parse(localStorage.getItem('menuPages'));
    if (menuPages) {
      menuPages.forEach(element => {
        if (element == APP_Constants.CREATE_ORDER) {
          this.createOrderAccess = true;
        }
        if (element == APP_Constants.SEARCH_ORDER) {
          this.searchOrderAccess = true;
        }
        if (element == APP_Constants.ORDERS_RELEASE) {
          this.releaseOrderAccess = true;
        }
      });
    }
  }

  checkHasPermission(role, type) {
    if (type === 'ROUTING') {
      try {
        let menuPages = JSON.parse(localStorage.getItem('menuPages'));
        if (menuPages) {
          let hasPermission = menuPages.indexOf(role);
          if (hasPermission > -1) {
            return true;
          } else {
            return false;
          }
        }

      } catch (e) {
        console.log('error--', e);
      }
    } else if (type === 'MODAL') {
      return true;
    } else {
      return false;
    }

  }

  navigateUrl(actionData, type) {
    if (type === 'ROUTING') {
      let url = actionData.command.url;
      if (url)
        this.router.navigateByUrl(url);
    } else if (type === 'MODAL') {
      this.actionEventHandler(actionData)
    }
  }

  /**
   *
   * @param actionData
   *
   * 1. Here we can add our custom event ex: ADDUSER,
   * 2. We can to add if condition below and need to create one custom method to handle that action
   * 3. Ex : 'ADDUSER' is action addUserHandler is method which have logic to create new user
   */
  actionEventHandler(actionData) {
    if (actionData.command.action == 'ADDUSER') {
      this.addUserHandler(actionData);
    }else if(actionData.command.action == 'ADDBULKUSER'){
      this.addBulkUserHandler(actionData);
    }
  }
  addBulkUserHandler(actionData) {
    let controls = actionData.command.controls;
    let addBulkUserformGroup: UntypedFormGroup = this.formService.createForm({ controls: controls });
    let modal = new Modal({
      action: false, name: actionData.command.action, title: 'Add Bulk User', description: 'Add New Bulk User form', actionButtonText: '',
      modalForm: { type: "common", modalName: 'addNewBulkUserModalForm', template: actionData.command, frmGroup: addBulkUserformGroup, editMode: true }
    });
    this.modalService.createModalBox(modal, 200);
    let obsr = this.appService._modalCommonFormSubjecct.subscribe(data => {
      if (data.name == actionData.command.action && data.event == 'submit') {
        if (addBulkUserformGroup.invalid) {
          this.formService.validateAllFormFields(addBulkUserformGroup);
          return;
        }
        this.uploadBulkDocument();
        this.modalService.closeModel();
        obsr.unsubscribe();
      }
      if (data.name == actionData.command.action && data.event == 'cancel') {
        this.modalService.closeModel();
        obsr.unsubscribe();
      }
    });
  }
  uploadBulkDocument(){
    this.isLoading = true;
    document.getElementById("overlay").style.display = "block";
    let fileData = this.appService.getUploadFileData();
    let formDataObj: FormData = new FormData();
    formDataObj.append('file', fileData, fileData.name);
    const uploadDocURL = APP_Constants.ADD_BULK_USER_DATA + "loggedInUser=" + localStorage.getItem('userName');
    this.appService.makeHttpPostRequest(uploadDocURL, formDataObj).subscribe((response) => {
      this.isLoading = false;
      this.normalView();
      this.bulkuserData = response
      this.router.navigateByUrl(APP_Constants.REDIRECT_BULK_STATUS_URL + this.bulkuserData.data.transactionId);
    }, (err) => {
      this.isLoading = false;
      this.normalView();

      let modal = new Modal({
        action: false, name: 'errorBulkUpload', title: 'Bulk User Upload', description: err.message, actionButtonText: ''
      });
      this.modalService.createModalBox(modal, err.message);
    });
  }
  addUserHandler(actionData) {
    let controls = actionData.command.controls;
    actionData.command.groups.filter((item)=>{ item.controls=item.controls.filter((resdata)=>{
      if(resdata.name=='secondaryUserRoles'){
        resdata.disabled=true;
        resdata.hidden=true;
      }
      return resdata.name!='dataRestrictions'})});
    let addGroups=actionData.command.groups;
    let addUserformGroup:UntypedFormGroup=this.formService.createForm({groups:addGroups})
    if(addUserformGroup.get('secondaryUserRoles')){
      addUserformGroup.get("secondaryUserRoles")['hidden'] = true;
    }
    let modal = new Modal({
      action: false, name: actionData.command.action, title: 'Add user', description: 'Add New User form', actionButtonText: '',
      modalForm: {  modalName: 'addUserModalForm', template: actionData.command.groups, frmGroup: addUserformGroup,editMode: true }
    });
    this.modalService.createModalBox(modal, 200);

    let obsr = this.appService._modalCommonFormSubjecct.subscribe(data => {
      if (data.name == actionData.command.action && data.event == 'submit') {

        if (addUserformGroup.invalid) {
          this.formService.validateAllFormFields(addUserformGroup);
          return
        }
        let url = APP_Constants.ADMIN_ADD_USER_URI;
        url += localStorage.getItem('userName');
        let formValue = data.formValue;
		let secUserRole = '';
		if(formValue.secondaryUserRoles)
		{
			secUserRole = formValue.secondaryUserRoles.toString()
		}
        let sub: any = {
          "customerCode": formValue.customerCode.value,
          "userRole": formValue.userRole.value,
    	  "secondaryUserRoles": secUserRole,
        };
        if (formValue.userRole.value == 'Vendor') {
          sub.parameterId = formValue.parameterId;
          sub.parameterValue = formValue.parameterValue;
		      sub.secondaryUserRoles = '';
        }
        let payload =
        {
          "firstName": formValue.firstName,
          "lastName": formValue.lastName,
          "email": formValue.email,
          "defaultCustomerCode": formValue.customerCode.value,
          "userCustomerSubscriptionList": [
            sub
          ]
        }
        this.modalService.closeModel();
        obsr.unsubscribe();
        //console.log("payload::",payload,addUserformGroup.valid);
        this.appService.makeHttpPostRequest(url, payload).subscribe((response) => {
          if (response['message'].statusCode == APP_Constants.SUCCESS_CODE) {
            this._snackBar.open({ orderId: '', message: response['message'].statusMessage }, { duration: this.durationInSeconds * 1000 });
            this.getSearchResultData({ target: { value: this.searchBoxVal } }, {});
          } else {
            this._snackBar.open({ orderId: '', message: response['message'].statusMessage }, { duration: this.durationInSeconds * 1000 });
            this.getSearchResultData({ target: { value: this.searchBoxVal } }, {});
          }
        }, err => {
          // this.modalService.closeModel();
          this._snackBar.open({ orderId: '', message: err['message'] }, { duration: this.durationInSeconds * 1000 });
          this.getSearchResultData({ target: { value: this.searchBoxVal } }, {});
        });
      }
      if (data.name == actionData.command.action && data.event == 'cancel') {
        obsr.unsubscribe();
        this.modalService.closeModel();
      }
    });
  }

  showOrder(orderId: string) {
    this.router.navigate(['orders', orderId]);
  }

  checkError(data) {
    this.formError = data;
  }

  searchList = [];
  // noItemFound;
  timeout = null;
  formError: String;
  searchMessage: String = '';

  getSearchResultData(data, filterObj) {
    let event: DhlFormControlEvent | null = this.checkEventExist(this.configData.events, 'change');
    if (event) {
      this.sendToSource(event, {$event:data,filterObj : filterObj});
      return
    }
    let key = data.which;
    let filterValue = data.target.value.trim();
    let filterObject = {};
    if (!(Object.keys(filterObj).length === 0 && filterObj.constructor === Object)) {
      filterObject = filterObj;
    }
    // this.noItemFound = false;
    let text;
    clearTimeout(this.timeout);
    if ((filterValue.length > 1 || filterValue.length == 0) && filterValue !== null && (key !== 32 && key !== 13)) {
      if (filterValue.length == 0) {
        text = '';
      } else {
        text = filterValue;
      }
      this.timeout = setTimeout(() => {
        this.formError = '';

        this.table.setSpinner();

        // let url = APP_Constants.SEARCH_ORDER_DATA+localStorage.getItem('customerCode') +
        //   "&userId=" + localStorage.getItem('userName') + "&searchString=" + text.toUpperCase();

        let url = '';

        let httpConfig = this.tabelConfig.httpConfig;

        let makeHttpRequest;
        let method = 'GET';
        let sourceNodeName = '';
        (text!= "" && text!= null && text!= undefined) ? sessionStorage.setItem(httpConfig.sourceNodeName,text.toUpperCase()) : sessionStorage.removeItem(httpConfig.sourceNodeName) ;

        if (httpConfig) {
          url = httpConfig.dataSource + text.toUpperCase();

          if (httpConfig.params && httpConfig.params.length) {
            httpConfig.params.forEach((param) => {
              url += param.key + '=' + localStorage.getItem(param.value) + '&';
            });
            url += '&' + httpConfig.searchKey + '=' + text.toUpperCase();
          }
          // url += "&sortBy=first_name-ASC"
          // url += "&pageSize=" + this.pageSize;
          url += "&pageNumber=" + this.pageNumber;

          method = httpConfig.method;
          sourceNodeName = httpConfig.sourceNodeName
        }
        if (method == 'GET') {
          if (filterObj) {
            for (let obj in filterObj) {
              if (filterObj[obj] != "" && filterObj[obj] !=null) {
                url += '&' + obj + '=' + filterObj[obj];
              }
            }
          }
          makeHttpRequest = this.appService.makeHttpGetRequest(url);
        } else {
          makeHttpRequest = this.appService.makeHttpPostRequest(url, filterObject);
        }

        makeHttpRequest.subscribe(data => {

          this.table.removeSpinner();
          if (data['message'].statusCode === APP_Constants.SUCCESS_CODE) {
            this.searchMessage = '';
            if (sourceNodeName == 'orders') {
              this.searchList = data[sourceNodeName];
            } else {
              this.searchList = data['data'].userdata;
            }
            // this.searchMessage = data['message'].statusMessage;   // need to remove this line
          } else if (data['message'].statusCode == APP_Constants.ERROR_CODE) {
            console.log(data['message'].statusMessage);
            this.searchMessage = data['message'].statusMessage;
            this.searchList = data[sourceNodeName];
          }
        }, (err) => {
          this.table.removeSpinner();
          this.formError = err;

          if (err.status === APP_Constants.NOT_FOUND) {
            this.searchMessage = err.message;
            this.searchList = [];
          } else {
            let modal = new Modal({
              action: false, name: 'searchOrder', title: 'Search Order', description: err.message, actionButtonText: ''
            });
            this.modalService.createModalBox(modal, err.status);
          }

        });
      }, CommonConfig.ORDER_SEARCH_TIMEOUT);
    }
    //this.table.filterTableData(filterValue);
  }
  getColsClass(cols: number[]) {
    const mediaBreakpoints = ['xl', 'lg', 'md', 'sm', 'xs'];
    let colsClass = '';
    for (let i = 0; i < cols.length; i++) {
      colsClass += 'col-' + mediaBreakpoints[i] + '-' + cols[i] + ' ';
    }
    return colsClass;
  }

  getFormTableControls() {
    return this.frmGroup.controls[this.configData.name]['controls'];
  }

  showHide: boolean = false;
  showDownArrow: boolean = true;
  hideForm() {
    this.showHide = false;
    if (!this.showHide) {
      this.showDownArrow = true;
    }
  }
  openDialog() {
    this.showHide = !this.showHide;
    if (this.showHide) {
      this.showDownArrow = false;
    }
  }

  searchOrderList() {
    console.log(this.frmGroup.value);
  }

  getFilterData(e) {
    this.searchBoxVal = "";
    this.getSearchResultData({ target: { value: '' } }, e);
    this.showHide = false;
    this.showDownArrow = true;
  }

  getFilterModal(e) {
    this.showHide = e;
  }

  /** Common Method to check event exist in template */
  checkEventExist(events, eventName): DhlFormControlEvent | null {
    let event = null;
    if (events && Array.isArray(events)) {
      event = events.filter(ele => ele.event == eventName);
      event = (event.length ? event[0] : null);
    }
    return event;
  }

  sendToSource(event: DhlFormControlEvent, data = {} ) {
    let eventData: DhlFormControlEventData = {
      event: event.event,
      eventData: event,
      action: event.action,
      name: this.configData.name,
      component: this,
      configData: this.configData,
      data: data,
    }
    this.appService._commonComponentSubject.next(eventData);
  }
}
